import { useEffect, useState } from "react";
import { requestAuth } from "../../../../../http/httpRequest";
import { useParams } from "react-router-dom";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from "chart.js";
import { useDispatch } from "react-redux";
import { toastOn } from "../../../../../store/slices/toast";
import * as dayjs from "dayjs";
import { RangeDate } from "../../../../../components/datePicker/CustomDateRangePicker";

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Tooltip, Legend);

export const VentasPorDia = ({ isGeneral }) => {
    const [data, setData] = useState([]);
    const [labels, setLabels] = useState([]);
    const dispatch = useDispatch();
    const params = useParams();

    // rango de fechas seleccionado
    const [selectedDay, setSelectedDay] = useState(undefined);
    const [paginate, setPaginate] = useState({ initial: "", final: "" });

    const getData = async () => {
        await requestAuth(
            "get",
            `/informe/cliente/${isGeneral ? 0 : params.user_cli_id}/ventasPorDia?initDate=${paginate.initial}&endDate=${paginate.final}`,
            null
        )
            .then((res) => {
                const start = paginate.initial
                    ? new Date(paginate.initial)
                    : new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                const end = paginate.final
                    ? new Date(paginate.final)
                    : new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

                const days = [];
                for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
                    days.push(dayjs(new Date(d)).format("YYYY-MM-DD"));
                }

                const ventasMap = {};
                res.data?.forEach((venta) => {
                    ventasMap[dayjs(venta.dia).format("YYYY-MM-DD")] = venta.total_ventas;
                });

                const fullData = days.map((d) => ({
                    dia: d,
                    total_ventas: ventasMap[d] || 0,
                }));

                setLabels(fullData.map((d) => dayjs(d.dia).format("DD/MM"))); // solo día/mes
                setData(fullData.map((d) => d.total_ventas));
            })
            .catch((error) => {
                dispatch(
                    toastOn({
                        type: "danger",
                        message: error?.response?.data?.message || "Error al listar ventas por día.",
                    })
                );
            });
    };

    useEffect(() => {
        if (paginate.initial && paginate.final) {
            getData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginate]);

    const chartData = {
        labels,
        datasets: [
            {
                label: `Ventas Totales`,
                data,
                fill: true,
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                borderColor: "rgba(75, 192, 192, 1)",
                borderWidth: 2,
                tension: 0.3,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { position: "top" },
            tooltip: {
                callbacks: {
                    label: (context) => `Bs. ${context.raw}`,
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: { display: true, text: `Ventas por día` },
                ticks: { color: "rgba(170,170,170)" },
                grid: { color: "rgba(170,170,170,.7)" },
            },
            x: {
                title: { display: true, text: "Días" },
                ticks: { color: "rgba(170,170,170)" },
                grid: { color: "rgba(170,170,170,.7)" },
            },
        },
    };

    return (
        <div>
            <div style={{ marginBottom: "20px", marginTop: "10px" }}>
                <div className="dark:text-gray-300 text-gray-800">
                    <h1 className="text-xl font-bold flex flex-col justify-center items-center gap-2">
                        <span>VENTA DE PRODUCTOS POR DÍA</span>
                        <RangeDate
                            setPaginate={setPaginate}
                            selectedDay={selectedDay}
                            setSelectedDay={setSelectedDay}
                            defaultThisMonth={true}
                        />
                    </h1>
                </div>
            </div>

            <Line data={chartData} options={options} />
        </div>
    );
};